import React, {Component} from 'react';
import Edit from 'react-feather/dist/icons/edit.js';
import Trash from 'react-feather/dist/icons/trash.js';
import ChevronDown from 'react-feather/dist/icons/chevron-down.js';
import ChevronUp from 'react-feather/dist/icons/chevron-up.js';
import { parseISO, isAfter } from 'date-fns';
import PropTypes from 'prop-types';

import connectModal from '../../../../../shared/components/Modals/connect.js';
import Date from '../../../../../shared/components/Moment/Date.jsx';
import MissionModal from "../../../../components/Modals/Mission/MissionModal.jsx";
import DeleteMissionModal from "../../../../components/Modals/Mission/DeleteMissionModal.jsx";
import PrimaryRoundedButton from "../../../../../shared/components/Styled/Buttons/PrimaryRoundedButton.jsx";
import DangerRoundedButton from "../../../../../shared/components/Styled/Buttons/DangerRoundedButton.jsx";
import SecondaryRoundedButton from "../../../../../shared/components/Styled/Buttons/SecondaryRoundedButton.jsx";
class Missions extends Component {
  static propTypes = {
    freelance: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      experiences: this.getSortedMissions(this.props.freelance?.experiences?.length ? this.props.freelance.experiences : []),
      experiencesVisibility : []
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const prevExperiences = prevProps.freelance?.experiences?.length ? prevProps.freelance.experiences : [];
    const experiences = this.props.freelance?.experiences?.length ? this.props.freelance.experiences : [];
    if (this.props.freelance.id !== prevProps.freelance.id || prevExperiences !== experiences) {
      this.setState({
        experiences: this.getSortedMissions(this.props.freelance?.experiences?.length ? this.props.freelance.experiences : [])
      });
    }
  }

  getSortedMissions = (experiences) => {
    return experiences
      .sort((a, b) => {
        if (a.current && !b.current) {
          return -1;
        }

        if (b.current && !a.current) {
          return 1;
        }

        const dateA = parseISO(a.start);
        const dateB = parseISO(b.start);
        if (dateA && dateB) {
          if (isAfter(dateA, dateB)) {
            return -1;
          } else {
            return 1;
          }
        } else {
          return 0;
        }
      });
  };
  currentExperienceVisibility = (offset) => {
    const indexFound  = this.state.experiencesVisibility.findIndex((visibility) => visibility.offset === offset)
    const visibilityItem = this.state.experiencesVisibility.at(indexFound)
    return (!visibilityItem) ? false : visibilityItem.visibility
  }

  toggleDescription = (offset) => {
    const currentVisibilities = this.state.experiencesVisibility
    const currentVisibilityToggled = !this.currentExperienceVisibility(offset)
    const newVisibilities = [
      ...currentVisibilities.filter((visibility) => visibility.offset !== offset),
      {offset: offset, visibility: currentVisibilityToggled}
    ]
    this.setState({experiencesVisibility : newVisibilities})
  }

  editExistingMission = (offset) => {
    this.props.openMissionModal({
      freelance: this.props.freelance,
      experiences: this.state.experiences,
      onClose: this.onClose,
      onSubmit: this.props.submit,
      offset
    });
  };

  deleteMission = (offset) => {
    this.props.openDeleteMissionModal({
      freelance: this.props.freelance,
      experiences: this.state.experiences,
      onClose: this.onClose,
      offset
    });
  };

  onClose = (exp) => {
    this.setState({experiences: this.getSortedMissions(exp)});
  };

  render() {
    return (
      <div>
        {this.state.experiences.map((experience, offset) => (
          <div className={this.props.className} key={offset} id={`experiences-${offset}`}>

            <div style={{display: 'flex'}}>
              <div style={{flex: 'auto'}}><h3 className="sub-sub-title">{experience.title }</h3></div>
              <div>{this.props.canEdit &&
                <div className="controls">
                  <PrimaryRoundedButton className={"mr-2"} onClick={() => this.editExistingMission(offset)}>
                    <Edit />
                  </PrimaryRoundedButton>
                  <DangerRoundedButton className={"mr-2"} onClick={() => this.deleteMission(offset)}>
                    <Trash />
                  </DangerRoundedButton>
                  <SecondaryRoundedButton  onClick={() => this.toggleDescription(offset)}>
                    {this.currentExperienceVisibility(offset) ?<ChevronUp />:<ChevronDown />}
                  </SecondaryRoundedButton>
                </div>
              }</div>
            </div>

            {(experience.title || experience.locality || experience.company) &&
            <div>
              {experience.title && experience.company && <span> chez </span>}
              {experience.company && <b>{experience.company}</b>}
              {(experience.company || experience.title) && experience.locality && <span> - </span>}
              {experience.locality && <span>{experience.locality}</span>}
            </div>
            }
            {(experience.start || experience.end || experience.current) &&
            <div>
              {(experience.start && <Date format="MM/yyyy" date={experience.start} />)}
              {(experience.start && (experience.current || experience.end) && <span> - </span>)}
              {(experience.current
                ? <span>Aujourd'hui</span>
                : (experience.end && <Date format="MM/yyyy" date={experience.end} />)
              )}
            </div>
            }
            {this.currentExperienceVisibility(offset) &&
              <div
                className={(experience.start || experience.end || experience.current || experience.title || experience.locality || experience.company) ? 'mt-2' : ''}
                dangerouslySetInnerHTML={{__html: experience.description}}>
              </div>
            }
          </div>
        ))}
      </div>
    );
  }
}

export default connectModal({ MissionModal, DeleteMissionModal }, Missions);